import React, { Component } from 'react';
import { RedText, BlueText, BigBold } from './LayoutComponents';

export class Prayers extends Component {

  render() {
    return (
      <div>
        <h2>기도문</h2>
        <br/>
        지금은 대한민국을 위해 기도할 때입니다. <br />
        깨어있는 우리 신부들이 국가와 교회를 위하여 진실된 회개기도를 하면 <br />
        우리 주님이 하늘에서 들으시고 받으십니다. <br />
        한국을 위해서 기도할 내용들이 너무 많습니다. <br />
        여기 중요한 내용들을 모아서 같이 기도하기를 부탁드립니다. <br />
        <br />
        같이 모여 기도할 때나 혹은 혼자서 기도할 때에 이기도문을 가지고 읽으면서 기도하십시요. <br />
        <br />
        <br />
        <BigBold>한국을 위한 진정한 회개 기도.</BigBold> <br />
        <br />
        <b>1.  나라 와 민족을 위한 기도</b> <br />
        <br />
        l. 은혜와 자비가 크신 하나님 아버지, <br />
        수천년 미신과 우상과 샤머니즘으로 하나님의 백성답게 살지 <br />
        못하였음을 회개합니다. <br />
        <BlueText>이 나라와 민족을 불쌍히 여겨 주시옵소서....</BlueText><br />
        <br />
        2. 일본의 압제 와 수탈 속에서 나라를 사랑하며 민족을 사랑했던 수많은 <br />
        독립투사들이 하나님의 보호하심을 믿고 생명을 아끼지 아니하였습니다. <br />
        전능하신 하나님께서 그들의 기도를 들으사 이 나라와 민족을 <br />
        구하여 주셨건만 하나님께 감사하지 못하였음을 회개 합니다. <br />
        <BlueText>이 나라 와 민족을 불쌍히 여겨 주시옵소서...</BlueText><br />
        <br />
        3. 대한민국은 하나님께서 소수의 의인들의 기도를 들으시고 건국의 기초부터 하나님께서 <br />
        간섭하시고 보호하셔서 세우신 나라임을 늦게나마 고백하고 감사드립니다. <br />
        그러나 반만년의 긴 역사 가운데 수 많은 선교사들의 피뿌림을 <br />
        허락하사 복음이 뿌리내리고 싹이 틀 수 있었음을 우리가 <br />
        감사치 아니하였음을 회개 합니다. <br />
        <BlueText>이 나라와 이 민족을 불쌍히 여겨 주시 옵소서.</BlueText> <br />
        <br />
        4. 몸을 찢으며 생명을 불살라 지켜낸 이 땅의 복음과 믿음과 <br />
        민주주의를 너무나 쉽게 친북 좌파에게 내어준 우리 국민의 <br />
        무지를 회개 합니다. <br />
        <BlueText>이 나라와 이 민족을 불쌍히 여겨 주시 옵소서.</BlueText> <br />
        <br />
        5. 하나님이 없다 하는 공산주의 사상과 북한이 주적의 상대가 <br />
        아니라 동행과 협력의 대상이라는 사상이 전교조를 통하여 <br />
        이 땅의 어린 아이들 과 청소년들에게 전파되는 것을 <br />
        막지 못한 것을 회개 합니다. <br />
        <BlueText>이 나라와 이 민족을 불쌍히 여겨 주시 옵소서.</BlueText> <br />
        <br />
        6. 지역 감정과 노조와 이념을 무기삼아 나라와 정치와 국민을 <br />
        이간질 시키고 분란케 하며 수많은 분쟁 과 데모 와 시위를 주도하는 <br />
        악한 세력을 이땅에서 뿌리 뽑지 못하였음을 회개 합니다. <br />
        <BlueText>이 나라와 이 민족을 불쌍히 여겨 주시 옵소서.</BlueText> <br />
        <br />
        <br />
        <b>2.  한국의 교회를 위한 기도</b> <br />
        <br />
        l. 교회가 기도가 없고 회개가 떠난 교회로 만든 <br />
        목회자들과 사역자들의 죄악을 용서하여 주시옵소서. <br />
        <br />
        2. 성령의 인도함을 받기 보다는 사람의 인정을 받아 유명해지기를 원하는 <br />
        목회자들 과 사역자들의 죄악을 용서하여 주시옵소서. <br />
        <br />
        3. 목회자들 과 사역자들이 자신을 우상화하고 하나님의 백성을 <br />
        자신의 소유로 착각하여 자신을 따르도록 인도하였음을 회개합니다. <br />
        이러한 교회를 불쌍히 여겨 주시 옵소서. <br />
        <br />
        4. 주님의 몸된 교회가 목회자들을 통하여 거대한 사업장이요 <br />
        또 회사가 되어 버렸음을 회개 합니다. <br />
        <br />
        5. 돈에 눈이 멀어 예수님 팔아 장사하는 목회자들, 자유신학으로 <br />
        가짜 복음을 가르치는 신학교 와 교수들을 용서하여 주옵소서. <br />
        <br />
        6. 하나님과 말씀을 두려워하지 않는 목회자들 과 교인들을 용서하여 주옵소서. <br />
        <br />
        7.  성령의 역사를 인정하지 않는 목회자들 과 사역자들, <br />
        또 이를 믿고 따르는 교인들을 용서하여 주옵소서. <br />
        <br />
        8. 거짓말하는 영이요 분란케 하는 악한 영이 교회안에 침투하여 <br />
        서로 정죄하고 헐뜯고 이단시비하며 분리되며 나뉘며 법정에 <br />
        이르도록 싸우는 것을 회개 합니다. <br />
        <BlueText>대한민국의 교회를 불쌍히 여겨 주시 옵소서.</BlueText> <br />
        <br />
        9. 강단의 말씀 과 교회 안에 철학과 심리학이 들어와 영적인 <br />
        말씀이 아니라 혼과 육의 필요를 충족 시키는 지식적 연설이 <br />
        넘쳐 나고 있음을 회개 합니다. <br />
        <BlueText>대한민국의 교회를 불쌍히 여겨 주시옵소서.</BlueText> <br />
        <br />
        10. 천국의 소망과 주님 오심을 기다리며 갈망하는 신실함을 <br />
        잃어버리고 이 땅의 소유와 형통과 육의 잘되는 것에 초점을 <br />
        맞춘 번영 신앙이 사람들의 마음과 교회안에 가득하게 되었음을 회개합니다. <br />
        <BlueText>대한민국의 교회를 불쌍히 여겨 주시옵소서.</BlueText> <br />
        <br />
        11. 죄를 죄라고 지적하지 못하고 지옥에 갈 수 있다는 것을 <br />
        선포하지 못하고 하나님의 징계가 있을 있음을 선포하지 못하는 <br />
        인본주의적이고 거짓 선지자와 같은 사역이 이 땅에 가득함을 <br />
        회개 합니다. <br />
        <BlueText>대한민국의 교회를 불쌍히 여겨 주시옵소서.</BlueText> <br />
        <br />
        12. 전쟁의 폐허속에서 어떤 자원도 없이 손바닥만한 땅덩어리와 <br />
        전쟁에 지친 사람들을 일으켜 지금의 부와 경제와 문화를 <br />
        허락하신 하나님..... <br />
        우리가 똑똑하고 우리가 부지런하고 우리가 열심히 일하여 <br />
        이 나라를 일으켰다고 착각하며 살았습니다. 이 교만과 이 불신을 회개합니다. <br />
        <BlueText>용서하여 주시옵소서.</BlueText> <br />
        <br />
        우리는 하나님의 은혜와 하나님의 긍휼과 하나님의 인자 때문에 <br />
        이 나라와 민족과 교회들이 지금 이렇게 성장하였음을 우리가 잊고 살았습니다. <br />
        <BlueText>하나님 아버지께 감사하지 않는 우리를 용서 하여 주옵소서.....</BlueText> <br />
        <br />
        13. 선교사님들의 목숨과 피로써 얻은 귀한 복음과 <br />
        신앙안에서 죄악과 분열이 틈 타도록 깨어 있지 못하였음을 <br />
        또 기도하지 못하였음을 회개 합니다. <br />
        <BlueText>우리를 용서하여 주옵소서.....</BlueText> <br />
        <br />
        <br />
        <b>3.  북한을 위한 기도</b> <br />
        <br />
        1. 주님, 저의 이기적이고 어린아이 같은 믿음으로 자라고 있음을 용서하여 주옵소서. <br />
        북한의 지하 교회 성도들의 기도를 외면하고 먼 이방나라의 이야기로만 <br />
        듣던 저를 용서하여 주옵소서. <br />
        <br />
        2. 영적으로는 북한의 성도들이 우리보다 훨씬 더 깊고 간절하고 주님 앞에 가까이 가 있지만 저희들은  <br />
        영의 눈이 가려서 알지 못하고 나의 배만 채우기에 급급하였습니다. <br /> 
        큰 죄를 지었습니다.  하나님의 긍휼하심으로 용서하여주시고 깨워서 기도하게 하옵소서. <br />
        <br />
        3. 복음을 듣지 못한 북한의 2천 5백만의 동포들에게도 복음이 들어가게 하여 주시옵소서. <br />
        <br />
        <br />
        <b>4.  개인을 위한 기도</b> <br />
        <br />
        1. 주님께서는 마지막때 깨어 있으라라고 외치셨지만 <br />
        영적 깨어있음보다는 잠자는 시간이 훨씬 더 많았음을 고백합니다. <br />
        주님 말씀에 불순종과 믿음없음을 용서하여 주시옵소서. <br />
        <br />
        2. 주님의 의와 하나님의 나라를 구하기보다는 아직도 <br />
        나의 눈에 제일 가까운 무엇을 먹을까, 무엇을 입을까, 무엇을 마실까에 <br />
        훨씬 더 생각과 시간을 많이 보내는 믿음 없는 저를 용서하여 주시옵소서. <br />
        <br />
        3. 주님, 제발 세상의 방법으로 머리써서 살지 않게 하시고, <br />
        기도하면서 주님의 가르쳐 주시는 방법으로 살게 하옵소서. <br />
        <br />
        사랑하는 주님, <br />
        <br />
        4. 내 양심에 부끄럽지 않게 거짓말하지 않고 정직하게 깨끗하고 <br />
        거룩하게 살도록 도와 주시옵소서. <br />
        <br />
        5. 사람들의 눈치보며 인정받기보다 나를 눈동자처럼 내려다 보시는 <br />
        하나님을 의식하고 두려워하며 하나님의 인정을 받는 참된 크리스챤이 되게 하옵소서. <br />
        <br />
        <br />
        <BlueText>하나님 아버지! <br />
        <br />
        아버지의 긍휼을 구합니다. 아버지의 용서를 구합니다. <br />
        <br />
        아버지의 인자를 구합니다. <br />
        <br />
        이 나라와 민족과 교회들을 불쌍히 여겨 주시옵소서..... <br />
        <br />
        이 나라와 민족과 교회들에게 다시 한번 기회를 주시옵소서..... <br />
        <br />
        진정으로 돌이키기를 원합니다. <br />
        <br />
        용서하여 주시옵소서..... <br />
        <br />
        하나님이 세우신 대한민국을 불쌍히 여기시고 구원하여 주시옵소서.</BlueText> <br />
        <br />
        <RedText>예수님의 몸이신 한국 교회들을 긍휼히 여기시고 <br />
        진정한 회개의 바람이 불게 하여 주시옵소서!!</RedText> <br />
        <br />
        자비 와 사랑이 많으신 거룩하신 우리구주 예수 그리스도 이름으로 기도합니다. <br />
        <br />
        아멘. <br />
        <br />
      </div>
    );
  }
}
